import { render, staticRenderFns } from "./LeadsKanban.vue?vue&type=template&id=531f6fbc&scoped=true&"
import script from "./LeadsKanban.vue?vue&type=script&lang=js&"
export * from "./LeadsKanban.vue?vue&type=script&lang=js&"
import style0 from "./LeadsKanban.vue?vue&type=style&index=0&lang=css&"
import style1 from "./LeadsKanban.vue?vue&type=style&index=1&id=531f6fbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531f6fbc",
  null
  
)

export default component.exports